var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-widget',{attrs:{"href":_vm.submitUrl,"coverImageUrl":_vm.form.coverImageUrl,"formName":_vm.formName,"callToAction":_vm.form.callToAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }